import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "due-date-tooltip-wrap" }
const _hoisted_2 = { class: "due-date-label" }
const _hoisted_3 = { class: "due-date" }

import { computed } from 'vue';
import useTranslate from '@/utilities/composables/useTranslate';
import { getHumanReadableDate } from '@/utilities/getHumanReadableDate';
import { fromUnixTime } from 'date-fns';

export default /*@__PURE__*/_defineComponent({
  __name: 'DueDateTooltip',
  props: {
    dueDate: {}
  },
  setup(__props: any) {

const { translate } = useTranslate();
const props = __props;

const monthsLabel = computed((): string => translate('months').split(','));

const dueDateLabel = (date: Date): string => {
  return getHumanReadableDate(date);
};

const getDateFromTimestamp = () => {
  const dueDate = fromUnixTime(props.dueDate);
  return `${translate('dueOn')}
          ${monthsLabel.value[dueDate.getMonth()]}
          ${dueDate.getDate()}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(dueDateLabel(props.dueDate * 1000)), 1),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, _toDisplayString(getDateFromTimestamp()), 1)
  ]))
}
}

})